document.querySelectorAll('.video-with-text').forEach(video => {
    setTimeout(() => {
        if (video.hasAttribute('autoplay')) {
            video.play();
        }
    }, 1000);

    video.addEventListener('click', () => {
    if (video.paused || video.ended) {
            video.play();
        } else {
            video.pause();
        }
    });
})
